"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConfiguration = exports.DefaultSchedulerConfiguration = void 0;
exports.DefaultSchedulerConfiguration = {
    defaultInterval: 5000,
    range: {
        min: 500,
        max: 20000,
    },
    batchSize: 10,
    retryPolicy: 'dropOnFail',
};
exports.DefaultConfiguration = {
    console: { enabled: false },
    authTokenFactory: undefined,
    serverLogConf: {
        enabled: false,
    },
    applicationHeaderFactory: undefined,
};
//# sourceMappingURL=configuration.js.map